import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const TITULOS = {
  '/dashboard': 'Meu Painel', '/schedule': 'Agenda', '/legal-kanban': 'Atividades', '/publications': 'Publicações',
  '/active-processes': 'Processos', '/concluded-processes': 'Processos concluídos', '/consulta-envolvido': 'Buscar processos',
  '/clients': 'Contatos', '/financeiro': 'Financeiro', '/document-templates': 'Modelos', '/template': 'Modelos',
  '/business-intelligence': 'Business Intelligence', '/desempenho': 'Desempenho', '/jurimetria': 'Jurimetria',
  '/yrm-academy': 'YRM Academy', '/settings': 'Configurações', '/company': 'Conta e assinatura', '/perfil': 'Meu perfil',
  '/registrations': 'Colaboradores', '/upload': 'Importar dados', '/admin-notifications': 'Avisos da plataforma', '/monitors': 'Monitoramento', '/apresentacao': 'Apresentação',
  '/notifications': 'Notificações', '/plataforma-admin': 'Administração Global', '/auditoria': 'Auditoria',
  '/login': 'Entrar', '/cadastro': 'Criar conta', '/recuperar-senha': 'Recuperar senha', '/redefinir-senha': 'Nova senha',
  '/portal-cliente/login': 'Portal do Cliente', '/portal-cliente/dashboard': 'Portal do Cliente',
}

// Cada tela tem o próprio título na aba: quem abre várias consegue distinguir
function TituloDaAba() {
  const { pathname } = useLocation()
  useEffect(() => {
    const titulo = TITULOS[pathname] || (pathname.startsWith('/document-editor') ? 'Editor de documentos' : '')
    document.title = titulo ? `${titulo} · YRM` : 'YRM Gestão Jurídica'
  }, [pathname])
  return null
}

export default TituloDaAba
